<mat-toolbar color="primary" class="fix-nav">
  <button type="button" mat-icon-button class="visible-md" (click)="toggleSidebar()">
    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
  </button>
  <div class="nav-brand">
    ngx-message-bus
  </div>
  <span class="nav-spacer"></span>
  <a href="https://www.npmjs.com/package/ngrx-message-bus"
     target="_blank"
     class="hidden-sm" mat-raised-button
     style="margin-right: 10px">
    <mat-icon>cloud_download</mat-icon>
    {{ 'Download Now' | translate }}
  </a>
  <button class="hidden-sm" mat-icon-button [matMenuTriggerFor]="profile">
    <mat-icon>account_circle</mat-icon>
  </button>
  <mat-menu #profile="matMenu">
    <button mat-menu-item>
      <mat-icon>person</mat-icon>
      <span>{{ 'Profile' | translate }}</span>
    </button>
    <button mat-menu-item>
      <mat-icon>inbox</mat-icon>
      <span>{{ 'Inbox' | translate }}</span>
    </button>
    <button mat-menu-item>
      <mat-icon>settings</mat-icon>
      <span>{{ 'Settings' | translate }}</span>
    </button>
  </mat-menu>
</mat-toolbar>
